/* eslint-disable @typescript-eslint/naming-convention */
import { Size } from '@ps/web-core-enums';
import type { DetailsGrid } from '@ps/web-martech-cms-types';
import { useScreenSize } from '@ps/web-shared-components';
import React from 'react';

import { CMSCTA, CMSPageSection } from '@swf/cms';

import styles from './CMSDetailsGrid.scss';
import CMSDetailsGridItem from './CMSDetailsGridItem';

const CMSDetailsGrid: React.FC<DetailsGrid> = ({
  heading,
  intro,
  item_alignment,
  items,
  cta,
  number_of_columns = 2,
  type = '',
  columns_distribution
}) => {
  const { greaterThan } = useScreenSize();
  const isMobile = !greaterThan(Size.Small);

  const gridTemplateColumns =
    columns_distribution && !isMobile
      ? columns_distribution.map(({ column_width: columnWidth }) => `${columnWidth}fr`).join(' ')
      : '1fr';

  if (!heading.title && !intro.content && items.length === 0) {
    return null;
  }

  return (
    <>
      <CMSPageSection
        heading={heading}
        intro={intro}
        grid
        columns={number_of_columns}
        gridClassName={styles[type as keyof typeof styles]}
        gridStyle={columns_distribution ? { gridTemplateColumns } : undefined}
      >
        {items.length &&
          items.map((item, index) => (
            <CMSDetailsGridItem {...item} alignment={item_alignment} key={index} />
          ))}
      </CMSPageSection>
      <CMSCTA {...cta} />
    </>
  );
};

export default CMSDetailsGrid;
